export default __webpack_public_path__ + "static/media/filter_user_blue.ad125130.svg";